import { createAction } from '@reduxjs/toolkit';

export const FETCH_MESSAGESESSIONS_ACTION_TYPE = 'saga/fetchMessageSessions';
export const fetchMessageSessionsAction = createAction(FETCH_MESSAGESESSIONS_ACTION_TYPE);
